import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { API, history } from '../helpers';
import { UserContext } from '../context/User';
import { readStoredUser } from '../helpers/utils';
import Loading from './Loading';

function PrivateRoute({ children }) {
  const location = useLocation();
  const [userState, userDispatch] = useContext(UserContext);
  const [authResolved, setAuthResolved] = useState(() => Boolean(readStoredUser()));

  useEffect(() => {
    const storedUser = readStoredUser();
    if (storedUser) {
      if (!userState.user) {
        userDispatch({ type: 'login', payload: storedUser });
      }
      setAuthResolved(true);
      return undefined;
    }

    let cancelled = false;
    const restoreSession = async () => {
      try {
        const res = await API.get('/api/user/self');
        const { success, data } = res.data || {};
        if (cancelled) {
          return;
        }
        if (success && data && typeof data === 'object') {
          localStorage.setItem('user', JSON.stringify(data));
          userDispatch({ type: 'login', payload: data });
        } else {
          localStorage.removeItem('user');
        }
      } catch (error) {
        localStorage.removeItem('user');
      } finally {
        if (!cancelled) {
          setAuthResolved(true);
        }
      }
    };

    setAuthResolved(false);
    void restoreSession();
    return () => {
      cancelled = true;
    };
  }, [userDispatch, userState.user]);

  const effectiveUser = userState.user || readStoredUser();
  if (effectiveUser) {
    return children;
  }

  if (!authResolved) {
    return <Loading label='正在校验登录状态...' minHeight='60vh' />;
  }

  return (
    <Navigate
      to='/login'
      replace
      state={{ from: location || history.location }}
    />
  );
}

export { PrivateRoute };
